<script lang="ts">
  const {
    size,
    text,
    onclick,
    type = 'button',
    disabled = false,
    filled = false,
    className = '',
  }: {
    size: 'small' | 'medium';
    text: string;
    onclick: () => void;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    filled?: boolean;
    className?: string;
  } = $props();
</script>

<button
  {type}
  class="btn gradient-border gradient-border--rounded {className}"
  class:btn--small={size === 'small'}
  class:btn--medium={size === 'medium'}
  class:btn--filled={filled}
  {onclick}
  {disabled}
>
  <span>{text}</span>
</button>

<style>
  @reference '$src/css/main.css';

  .btn {
    @apply relative flex items-center justify-center gap-2 rounded-full;
    @apply bg-yellow text-black transition-all duration-500 hover:bg-transparent hover:text-white;
    @apply text-center leading-[150%] font-extrabold tracking-[0.175em] whitespace-nowrap uppercase;

    &::before {
      @apply bg-yellow opacity-0;
    }

    &:hover::before {
      opacity: 1;
    }
  }

  .btn--small {
    @apply h-12 px-6 text-xs;
  }

  .btn--medium {
    @apply h-12 px-6 text-xs sm:h-14 sm:text-sm;
  }

  .btn--filled {
    @apply hover:bg-black;
  }

  .btn:disabled {
    @apply cursor-not-allowed opacity-50;
  }
</style>
